const AllAssetsActionTypes = {
    START_FETCH_ALL_ASSETS: 'START_FETCH_ALL_ASSETS',
    SUCCESS_FETCH_ALL_ASSETS: 'SUCCESS_FETCH_ALL_ASSETS',
    FAILURE_FETCH_ALL_ASSETS: 'FAILURE_FETCH_ALL_ASSETS',
    FINISH_FETCH_ALL_ASSETS: 'FINISH_FETCH_ALL_ASSETS',

    START_GET_QUICK_DEPOSIT_ASSET: 'START_GET_QUICK_DEPOSIT_ASSET',
    SUCCESS_GET_QUICK_DEPOSIT_ASSET: 'SUCCESS_GET_QUICK_DEPOSIT_ASSET',
    FINISH_GET_QUICK_DEPOSIT_ASSET: 'FINISH_GET_QUICK_DEPOSIT_ASSET',
    FAILURE_GET_QUICK_DEPOSIT_ASSET: 'FAILURE_GET_QUICK_DEPOSIT_ASSET',
}

export default AllAssetsActionTypes
